import React from 'react';
import { disclaimerText1, disclaimerText2 } from '../constants/Constants';

interface DisclaimerDialogInterface {
    isNewGame: boolean;
    startGame: any;
    joinGame: any;
    closeDialog: any;
};

function DisclaimerDialog({isNewGame, startGame, joinGame, closeDialog}: DisclaimerDialogInterface) {

    const handleCancel = () => {
        closeDialog();
    }

    const handleAcknowledge = () => {
        if (isNewGame) {
            startGame();
        } else {
            joinGame();
        }
    }

    return (
        <div className="disclaimerWrapper">
            <h1 className="disclaimerTitle">DISCLAIMER</h1>
            <div className="disclaimerAcknowledgementText">{disclaimerText1 + " " + disclaimerText2 + " Play at your own risk, your friends may block you after this game."}</div>
            <button className="disclaimerAcknowledgeButton" onClick={handleAcknowledge}>I ACKNOWLEDGE</button>
            <button className="disclaimerCancelButton" onClick={handleCancel}>CANCEL</button>
        </div>
    );
};

export default DisclaimerDialog;